const formatMoney = (value) => {
  if (value === null || value === undefined) return "-";
  return `$${Number(value).toLocaleString('es-AR')}`;
};

export const formatRows = (data) => {
  
  return data.map((item) => ({
    id: item.id,
    nombre: item.nombre || "-",
    sucursal: item.sucursal?.nombre || "-",
    radio_km: item.radio_km ? `${item.radio_km} km` : "-",
    monto_minimo: formatMoney(item.monto_minimo),
    costo_envio: formatMoney(item.costo_envio),
    envio_gratis_desde: item.envio_gratis_desde ? formatMoney(item.envio_gratis_desde) : "No aplica",
    acepta_entregas: item.acepta_entregas === 1 
      ? "🟢 Activa" 
      : "🔴 Pausada",
    activa: item.activa,
  }));
};

export default formatRows;
